// extracted by mini-css-extract-plugin
export default {"root":"IconPickerTabs_root__llZGd","heightCondensed":"IconPickerTabs_heightCondensed__TY4-0"};